export default "__VITE_ASSET__BrsVUl0h__"